import { useState } from 'react';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { submitCsatSurvey } from '../api/surveyApi';
import { jsx as _jsx } from "react/jsx-runtime";
const FeedbackSurveySubmitButton = ({
  children,
  followUp,
  onClick,
  surveyConfig
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  return /*#__PURE__*/_jsx(LoadingButton, {
    "data-test-id": "survey-submit-button",
    loading: isSubmitting,
    onClick: () => {
      if (followUp) {
        const {
          surveyId
        } = surveyConfig.config;
        const {
          contactId
        } = surveyConfig.webRespondent;
        setIsSubmitting(true);
        // Voiding so we don't have to handle the error in this function
        // The error is already caught in `submitCsatSurvey`
        void submitCsatSurvey({
          surveyId,
          contactId,
          rating: 2,
          followUp
        }).finally(() => {
          setIsSubmitting(false);
          onClick(followUp);
        });
      } else {
        onClick();
      }
    },
    size: "sm",
    use: "primary",
    children: children
  });
};
export default FeedbackSurveySubmitButton;